import React, { useEffect } from "react";
import Carousel from "./Carousel";

const ProjectModal = ({ project, onClose }) => {
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => (document.body.style.overflow = "");
  }, []);

  const handleKey = (e) => {
    if (e.key === "Escape") onClose();
  };

  const handleViewRepo = () => {
    window.open(
      project?.repoAvailability
        ? project.repoUrl
        : "https://reponotfound.leocode.tech",
      "_blank"
    );
  };

  const handleViewProject = () => {
    window.open(
      project?.deployed
        ? project.projectUrl
        : "https://depnotfound.leocode.tech",
      "_blank"
    );
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="modal-content glass-effect"
        onClick={(e) => e.stopPropagation()}
        onKeyDown={handleKey}
      >
        <button className="modal-close" onClick={onClose}>
          ×
        </button>
        <div className="modal-header">
          <h2 className="modal-title">{project.title}</h2>
        </div>
        <Carousel project={project} />
        <div className="modal-body">
          <p className="modal-description">{project.description}</p>
          <p className="modal-tools">Tools: {project.tools}</p>
        </div>
        <div className="modal-actions">
          <button className="action-btn repo-btn" onClick={handleViewRepo}>
            View Repo
          </button>
          <button
            className="action-btn project-btn"
            onClick={handleViewProject}
          >
            View Project
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProjectModal;
